import { type createListenerMiddleware, isAnyOf } from '@reduxjs/toolkit';
import { fulfilledWithSettingsMatcher, type SettingsAction, updatePersistor } from 'BreetHelpers';
import {
	apiSlice,
	type AppDispatch,
	clearCountDownStartTimeArray,
	logUserIn,
	logUserOut,
	type RootState,
	setAuthSettings,
	setCountDownStartTimeArray,
	setFcmToken,
	setIs2faAlert,
	setIsApprovedForLive,
	setIsFiatBalanceHidden,
	setShowSecretKey,
	setTargetEnvironment,
	setThemeMode,
} from 'BreetRedux';

export function appListeners(mw: ReturnType<typeof createListenerMiddleware>) {
	const startAppListening = mw.startListening.withTypes<RootState, AppDispatch>();

	startAppListening({
		predicate: isPersistenceAction,
		effect: (_, api) => {
			const state = api.getState();
			updatePersistor({
				countDownStartTimeArray: state.app.countDownStartTimeArray,
				themeMode: state.app.themeMode,
				isUserLoggedIn: state.app.isUserLoggedIn,
				lastVisited: state.app.lastVisited,
				fcmToken: state.app.fcmToken,
				isFiatBalanceHidden: state.app.isFiatBalanceHidden,
				showSecretKey: state.app.showSecretKey,
				is2faAlert: state.app.is2faAlert,
				targetEnvironment: state.app.targetEnvironment,
				isApprovedForLive: state.app.isApprovedForLive,
			});
		},
	});

	startAppListening({
		predicate: fulfilledWithSettingsMatcher,
		effect: (action, api) => {
			const { payload } = action as unknown as SettingsAction;
			if (payload.meta?.settings?.fxRates) {
				api.dispatch(setAuthSettings(payload.meta.settings));
			}
		},
	});

	startAppListening({
		actionCreator: setTargetEnvironment,
		effect: (_, api) => {
			api.dispatch(apiSlice.util.resetApiState());
		},
	});
}

const isPersistenceAction = isAnyOf(
	clearCountDownStartTimeArray,
	setCountDownStartTimeArray,
	setThemeMode,
	setIsFiatBalanceHidden,
	setFcmToken,
	setShowSecretKey,
	logUserIn,
	logUserOut,
	setIs2faAlert,
	setTargetEnvironment,
	setIsApprovedForLive
);
